// Dintass: pestañas del menú desplegable (snippets/dt-mega-tabs.liquid).
// Al pasar el mouse, enfocar o tocar un grupo de la izquierda se muestra su panel a la derecha.
function activar(tab) {
  const root = tab.closest('[data-dt-mt]');
  if (!root || tab.classList.contains('is-active')) return;
  const n = tab.dataset.dtMtTab;
  root.querySelectorAll('[data-dt-mt-tab]').forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
  root.querySelectorAll('[data-dt-mt-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.dtMtPanel === n));
}
let timer;
document.addEventListener('mouseover', (e) => {
  const tab = e.target instanceof Element && e.target.closest('[data-dt-mt-tab]');
  if (!tab) return;
  clearTimeout(timer);
  timer = setTimeout(() => activar(tab), 60);
});
document.addEventListener('focusin', (e) => {
  const tab = e.target instanceof Element && e.target.closest('[data-dt-mt-tab]');
  if (tab) activar(tab);
});
// En pantallas táctiles el primer toque abre la pestaña; el segundo sigue el enlace
document.addEventListener('click', (e) => {
  const tab = e.target instanceof Element && e.target.closest('[data-dt-mt-tab]');
  if (tab && !tab.classList.contains('is-active') && matchMedia('(hover: none)').matches) { e.preventDefault(); activar(tab); }
});

// Fotos del menú: se cargan al entrar con el mouse, el foco o el dedo al ítem que contiene el desplegable
function cargarFotos(e) {
  const nav = e.target instanceof Element && e.target.closest('.menu-list');
  if (!nav) return;
  let el = e.target;
  while (el && el !== nav) {
    const mt = el.querySelector('[data-dt-mt]');
    if (mt) {
      mt.querySelectorAll('img[data-dt-src]').forEach((i) => { i.srcset = i.dataset.dtSrcset; i.src = i.dataset.dtSrc; i.removeAttribute('data-dt-src'); });
      return;
    }
    el = el.parentElement;
  }
}
['mouseover', 'focusin', 'touchstart'].forEach((ev) => document.addEventListener(ev, cargarFotos, { passive: true }));
